import api from '../../services/service_calendar'
import apiCenter from '../../services/service_undefined'
import AlertPostponse from '../../components/alert_postponse'
import AlertSuccess from '../../components/alert_success'

export default {
  components: {
    AlertPostponse,
    AlertSuccess
  },
  data () {
    return {
      now_month: '',
      events: [],
      isReminder: true,
      remainingData: []
    }
  },
  methods: {
    toggleIsReminder (page) {
      if (page === 1) {
        this.isReminder = true
      } else {
        this.isReminder = false
      }
    },
    getData () {
      this.$store.commit('Loading')
      this.now_month = this.dateFormatDMY2(new Date()).split('-')
      let obj = {
        get_year: parseInt(this.now_month[0]),
        get_month: parseInt(this.now_month[1]),
        get_day: parseInt(this.now_month[2])
      }
      api.list(
        this.REST_URL,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        obj,
        result => {
          // console.log(result)
          if (result.response === 'success') {
            console.log(result.data)
            let data = []
            for (let cal of result.data.filter(e => e.status === 0)) {
              data.push(cal)
            }
            for (let cal of result.data.filter(e => e.status === 3)) {
              data.push(cal)
            }
            for (let cal of result.data.filter(e => e.status === 1)) {
              data.push(cal)
            }
            this.events = data
            if (this.events.length > 0) {
              $('#notiCalendar').modal('show')
            }
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลปฎิทิน',
              description: result.message
            })
          }
          const config = JSON.parse(localStorage.getItem('config'))
          if (config.length > 0) {
            const branchName = config[0].branch_name.replaceAll(' ', '')
            // $('#notiCalendar').modal('show')
            // apiCenter.getMenimumStock(
            //   {
            //     branchName: branchName
            //   },
            //   results => {
            //     $('#notiCalendar').modal('show')
            //     if (results.data.result) {
            //       for (var i = 0; i < results.data.result.length; i++) {
            //         let value = {
            //           text: results.data.result[i].name,
            //           remain: results.data.result[i].stock_qty,
            //           unit: results.data.result[i].stk_unit_code
            //         }
            //         this.remainingData.push(value)
            //       }
            //     }
            //   },
            //   errors => {}
            // )
          }
          this.$store.commit('Loading')
        },
        error => {
          console.log('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    goTo (path) {
      $('body').on('hidden.bs.modal', '.modal', function () {
        $(this).removeData('bs.modal')
      })
      $('#notiCalendar').modal('hide')
      this.$router.push(path)
    },
    openActivity (data) {
      // console.log(data)
      this.$store.state.activity_detail = data
    }
  },
  mounted () {
    if (
      sessionStorage.token !== undefined &&
      sessionStorage.token !== 'undefined'
    ) {
      this.getData()
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/calendar_day.js